import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarRefresh = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "calendar-refresh" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.25,17.25h-6a1.5,1.5,0,0,1-1.5-1.5v-12a1.5,1.5,0,0,1,1.5-1.5h13.5a1.5,1.5,0,0,1,1.5,1.5v4.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .75,
			y1: 6.75,
			x2: 17.25,
			y2: 6.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.25,
			y1: 3.75,
			x2: 5.25,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12.75,
			y1: 3.75,
			x2: 12.75,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "15 18.75 11.25 18.75 11.25 22.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M22.667,19.484a5.573,5.573,0,0,1-10.74-.734"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "19.5 15.75 23.25 15.75 23.25 12"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M11.833,15.017a5.572,5.572,0,0,1,10.74.733"
		})
	]
});
export default SvgCalendarRefresh;
